import { Link } from "react-router-dom"
import Header from "../../components/forms/Header"
import RequestAccountDeletion from "../../components/deleteAccount/RequestAccountDeletion"
import { usePublicSiteBranding } from "../../contexts/PublicSiteContext"

export default function DeleteAccountPage() {
  const branding = usePublicSiteBranding()

  return (
    <section
      className={`flex pt-6 md:pt-none md:items-center md:pb-44 justify-center md:w-full ${branding.authPageMdGradientClass}`}
    >
      <div className="md:w-2/4 lg:max-w-xl md:p-5 md:shadow-xl md:rounded-xl bg-white">
        <Header heading="Delete your account" paragraph="" linkName="" linkUrl="" />
        <p className="text-center text-sm text-gray-600 mt-2 px-2">
          Deleting your {branding.productDisplayName} account will remove your personal account data.
          Walk records and company operational history are retained because they were created as part
          of work performed for the company. Enter the email address associated with your account below.
          We will email you a link to confirm deletion—your account is not removed until you confirm
          that email.
        </p>
        <RequestAccountDeletion />
        <div className="flex justify-between pt-4 text-sm">
          <Link to="/" className="text-black hover:text-primary">
            Return to home
          </Link>
          <Link to="/login" className="text-slate-500 hover:text-primary">
            Login
          </Link>
        </div>
      </div>
    </section>
  )
}
